module.exports = __webpack_public_path__ + "img/agentLogo.03f46f96.png";